import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Supplements from './supplements';
import SupplementsDetail from './supplements-detail';
import SupplementsUpdate from './supplements-update';
import SupplementsDeleteDialog from './supplements-delete-dialog';

const SupplementsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Supplements />} />
    <Route path="new" element={<SupplementsUpdate />} />
    <Route path=":id">
      <Route index element={<SupplementsDetail />} />
      <Route path="edit" element={<SupplementsUpdate />} />
      <Route path="delete" element={<SupplementsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SupplementsRoutes;
